import { render, staticRenderFns } from "./ModalCreateOrganization.vue?vue&type=template&id=61caf845"
import script from "./ModalCreateOrganization.vue?vue&type=script&lang=js"
export * from "./ModalCreateOrganization.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateOrganization.vue?vue&type=style&index=0&id=61caf845&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports